const NBSP = '\u00A0'

const SHORT_WORDS = [
  'а', 'и', 'к', 'о', 'с', 'у', 'в', 'я',
  'во', 'ко', 'со', 'об', 'от', 'до', 'по', 'из', 'на', 'за', 'не', 'но', 'ни', 'бы', 'ли', 'же',
  'для', 'при', 'про', 'без', 'под', 'над', 'или', 'что', 'как', 'то', 'это', 'ещё', 'еще',
  'уже', 'все', 'всё', 'так', 'тоже', 'если', 'чтобы', 'лишь', 'либо', 'лишь',
  'наш', 'наша', 'наше', 'наши', 'ваш', 'ваша', 'ваше', 'ваши',
  'его', 'её', 'ее', 'их', 'там', 'тут', 'где', 'кто', 'чем'
]

const SHORT_WORDS_PATTERN = SHORT_WORDS
  .sort((a, b) => b.length - a.length)
  .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  .join('|')

const TYPO_REGEX = new RegExp(
  `(^|[\\s(,—–-])(${SHORT_WORDS_PATTERN}) (?!${NBSP}|&nbsp;)`,
  'gim'
)

/**
 * Проставляет неразрывные пробелы после коротких предлогов, союзов и местоимений.
 * @param {string} text
 * @returns {string}
 */
export function typo(text) {
  if (!text || typeof text !== 'string') return text
  return text.replace(TYPO_REGEX, (_, before, word) => `${before}${word}${NBSP}`)
}

/**
 * Типографика для HTML-описаний с сервера: обрабатывает только текст между тегами.
 * @param {string} html
 * @returns {string}
 */
export function typoHtml(html) {
  if (!html || typeof html !== 'string') return html

  return html.replace(/(<[^>]+>)|([^<]+)/g, (match, tag, text) => {
    if (tag) return tag
    if (text) return typo(text)
    return match
  })
}

/**
 * Директива для текстовых узлов без вложенной разметки.
 */
export const typoDirective = {
  mounted(el) {
    applyTypoToElement(el)
  },
  updated(el) {
    applyTypoToElement(el)
  }
}

function applyTypoToElement(el) {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT)
  let node = walker.nextNode()
  while (node) {
    const formatted = typo(node.textContent)
    if (formatted !== node.textContent) {
      node.textContent = formatted
    }
    node = walker.nextNode()
  }

  applyTypoToPlaceholders(el)
  if (el !== document.body && el.querySelectorAll) {
    el.querySelectorAll('[placeholder]').forEach(applyTypoToPlaceholders)
  }
}

function applyTypoToPlaceholders(el) {
  if (!el?.getAttribute) return

  const placeholder = el.getAttribute('placeholder')
  if (!placeholder) return

  const formatted = typo(placeholder)
  if (formatted !== placeholder) {
    el.setAttribute('placeholder', formatted)
  }
}
